import { ABOUT_OFFSET, SERVICES_OFFSET, PORTFOLIO_OFFSET } from "../actions/types";

export default (state = null, action) => {
    switch(action.type){
        case ABOUT_OFFSET:
            return {...state, aboutOffset: action.payload};
        case SERVICES_OFFSET:
            return {...state, servicesOffset: action.payload};
        case PORTFOLIO_OFFSET:
            return {...state, portfolioOffset: action.payload};
        default:
            return state;
    }
}